<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm4 offset-sm4 pt-5>

        <v-alert  :value="true"  v-if="error != null" type="error" >{{ error.message }}</v-alert>
        <v-alert  :value="true"  v-if="success != null" type="success" >{{ success.message }}</v-alert>
      
        <v-layout justify-center column>
          <v-form ref="form" v-model="valid" lazy-validation @submit="changeEmail" v-if="verify==false">
            
            <v-layout row>
              <v-flex xs12 pt-0 pb-4>
                <p class="notice">Please enter your new email address. Once you click the 'Send Verification Code' button you will be sent a code to the new email address, which you will then have to enter in a field that will appear after the button is clicked.</p>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12>
                <v-text-field outline v-model="username" :rules="usernameRules" label="Email"  required ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row align-center mx-1>
              <v-spacer />
              <button type="submit" class="button" :disabled="!valid">Send Verification Code</button>
            </v-layout>

          </v-form>
          <div  v-else>
          <v-form ref="form" v-model="valid" lazy-validation @submit="verfifyCode">
             <v-layout row>
              <v-flex xs12 pt-0 pb-4>
                <p class="notice">Your email address has been updated but now must be verified. Please enter the code that we have just sent to your updated email address in the box below. If you can not see a code in your email inbox please check for emails from noreply@mywire.warringtonwolves.com in your junk.</p>
              
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-text-field outline v-model="verificationCode" label="Verification Code"  required ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row align-center mx-1>
              <v-spacer />
              <button type="submit" class="button" :disabled="!valid">Submit Verification Code</button>
            </v-layout>
           </v-form>
           <v-form ref="form" v-model="valid" lazy-validation @submit="sendCode">
             <v-layout row>
              <v-flex xs12 pt-0 pb-4>
                <p class="notice">To resend a code please click the button below.</p>
              </v-flex>
            </v-layout>
            <v-layout row align-center mx-1>
              <v-spacer />
              <button type="submit" class="button" :disabled="!valid">Send Another Code</button>
            </v-layout>
           </v-form>  
          </div>
        </v-layout>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'UserProfileChangeEmail',
  data () {
    
    return {
      valid: true,
      usernameRules: [
        v => !!v || 'Email address is required',
        v => /.+@.+/.test(v) || 'Email must be valid'
      ],
      username: '',
      verificationCode:'',
      error: null,
      success: null,
      loading: false,
      verify: false
    }
  },
  created () {
  },
  methods: {
    changeEmail (e) {
        e.preventDefault()
        this.ready = false
        
        var email = this.username.toLowerCase()
        var attributesList = {
          "email": email
        }
        this.$updateAttributes(attributesList).subscribe((response) => {
          console.log("update successful")
          this.error = null
          this.success = {message: 'Your email has been changed. You must now enter your verification code in the box below.'}
          this.ready = true
          this.verify = true
        }, 
        (err)=> {
          //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
          // console.log(err.message)
          this.success = null
          this.error = err
          this.ready = true
        });       
    },
    verfifyCode (e)  {
        e.preventDefault()
        this.ready = false
                  
        var verificationCode = this.verificationCode
        
        console.log('verificationCode', verificationCode)
        this.$verifyEmail(verificationCode).subscribe((response) => {
          console.log("verify successful")
          this.error = null
          this.success = {message: 'Your email has now been verified. Thank you.'}
          this.ready = true
          this.verify = false
        }, 
        (err)=> {
          this.success = null
          this.error = err
          this.ready = true
        });    
           
    },
    sendCode (e)  {
        e.preventDefault()
        this.ready = false
                  
        this.$sendVerifyEmailCode().subscribe((response) => {
          console.log("verify successful")
          this.error = null
          this.success = {message: 'We have sent you a new verification code.'}
          this.ready = true
          this.verify = true
        }, 
        (err)=> {
          this.success = null
          this.error = err
          this.ready = true
        });    
           
    }
  }
}
</script>

<style scoped>
</style>